import { Component, OnInit, Input } from '@angular/core';

import { InventoryService } from '../../services/inventory.service';

@Component({
  selector: 'app-article-item',
  providers: [InventoryService],
  templateUrl: './article-item.component.html',
  styleUrls: ['./article-item.component.css']
})
export class ArticleItemComponent implements OnInit {

  @Input("position") position: any;
  @Input("iscomplete") iscomplete: boolean;
  @Input("ovp") ovp: any[] = [];
  @Input("scanItems") scanItems: number = 0;
  article: any;

  constructor(private storageService: InventoryService) { }

  ngOnInit() { }

  ngOnChanges(changes: any) {
    this.getArticle(this.position.articleRef);
  }

  getStoragePlaces() {
    if (this.article == null || this.article.shelves == null) {
      return null;
    }
    this.article.shelves.sort((left, right): number => {
      if (left.name < right.name) return -1;
      if (left.name > right.name) return 1;
      return 0;
    });
    return this.article.shelves.filter(shelf => shelf.name!='shopping_cart');
  }

  getArticle(articleRef: string) {
    this.storageService.getArticle(articleRef)
      .subscribe(
        data => {
          this.article = data;
        },
        error => {
          // do nothing, just dont show any article info
        });
  }

  isArticleOVP(articleRef: string) {
    return this.ovp.includes(articleRef);
  }
  

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/orders/article-item/article-item.component.ts